import { IDropdownOptions } from '@poste-click-connect/shared-ui';
import { emptyValueDropdown } from '../../../../utils/generic';

export const systemOptions: IDropdownOptions<null>[] = [
  {
    id: 'crm',
    payload: null,
    label: 'CRMO',
  },
  {
    id: 's4hana',
    payload: null,
    label: 'S4/HANA',
  },
];

export const systemOptionsLocker: IDropdownOptions<null>[] = [
 /* {
    id: 'crm',
    payload: null,
    label: 'CRMO',
  },
  {
    id: 's4hana',
    payload: null,
    label: 'S4/HANA',
  },*/
  {
    id: 'dashboard',
    payload: null,
    label: 'DASHBOARD LOCKER',
  },
];

export const typeOptionsDashboard: IDropdownOptions<null>[] = [
  emptyValueDropdown,
  {
    id: 'C',
    payload: null,
    label: 'C - CREAZIONE LOCALITA\'',
  },
  {
    id: 'SO',
    payload: null,
    label: 'SO - SOSPENSIONE LOCKER',
  },
];

export const typeOptionsCrm: IDropdownOptions<null>[] = [
  emptyValueDropdown,
  {
    label: 'C - Creazione contratto',
    payload: null,
    id: 'C',
  },
  {
    label: 'U - Modifica contratto',
    payload: null,
    id: 'U',
  },
  {
    label: 'SO - Sospensione contratto',
    payload: null,
    id: 'SO',
  },
];

export const typeOptionsS4hana: IDropdownOptions<null>[] = [
  emptyValueDropdown,
  {
    id: 'F',
    payload: null,
    label: 'F - CREAZIONE FORNITORE',
  },
  {
    id: 'M',
    payload: null,
    label: 'M - MODIFICA FORNITORE',
  },
];

export const statusAnagCrmoOptions: IDropdownOptions<null>[] = [
  emptyValueDropdown,
  {
    label: 'CREATA',
    payload: null,
    id: 'CREATA',
  },
  {
    label: 'MODIFICATA',
    payload: null,
    id: 'MODIFICATA',
  },
  {
    label: 'ATTR. CRITICI VARIATI',
    payload: null,
    id: 'ATTR. CRITICI VARIATI',
  },
  {
    label: 'MODIFICATA E ATTR. CRITICI VARIATI',
    payload: null,
    id: 'MODIFICATA E ATTR. CRITICI VARIATI',
  },
  {
    label: 'GIA’ ALLINEATA',
    payload: null,
    id: 'GIA’ ALLINEATA',
  },
  {
    label: 'ERR. SU RICHIESTA',
    payload: null,
    id: 'ERR. SU RICHIESTA',
  },
  {
    label: 'ERR. SU ESITO',
    payload: null,
    id: 'ERR. SU ESITO',
  },
  {
    label: 'ERR. COMUNICAZ. (RETRY)',
    payload: null,
    id: 'ERR. COMUNICAZ. (RETRY)',
  },
  {
    label: 'ERR. COMUNICAZ.',
    payload: null,
    id: 'ERR. COMUNICAZ.',
  },
  {
    label: 'ERR. GENERICO',
    payload: null,
    id: 'ERR. GENERICO',
  },
];

export const statusAnagTypeS4HanaOptions: IDropdownOptions<null>[] = [
  emptyValueDropdown,
  {
    id: 'FORNITORE CREATO',
    payload: null,
    label: 'FORNITORE CREATO',
  },
  {
    id: 'FORNITORE MODIFICATO',
    payload: null,
    label: 'FORNITORE MODIFICATO',
  },
  {
    id: 'ERRORE SU ESITO FORNITORE',
    payload: null,
    label: 'ERRORE SU ESITO FORNITORE',
  },
  {
    id: 'ERRORE DI COMUNICAZIONE',
    payload: null,
    label: 'ERRORE DI COMUNICAZIONE',
  },
];

export const statusAccordoOptions: IDropdownOptions<null>[] = [
  emptyValueDropdown,
  {
    label: 'ERR. SU ESITO',
    payload: null,
    id: 'ERR. SU ESITO',
  },
  {
    label: 'ERR. COMUNICAZ. (RETRY)',
    payload: null,
    id: 'ERR. COMUNICAZ. (RETRY)',
  },
  {
    label: 'ERR. COMUNICAZ.',
    payload: null,
    id: 'ERR. COMUNICAZ.',
  },
  {
    label: 'ERR. GENERICO',
    payload: null,
    id: 'ERR. GENERICO',
  },
  {
    label: "GIA' ALLINEATO",
    payload: null,
    id: "GIA' ALLINEATO",
  },
  {
    label: 'In elaborazione',
    payload: null,
    id: 'In elaborazione',
  },
  {
    label: 'In verifica pre-attivazione',
    payload: null,
    id: 'In verifica pre-attivazione',
  },
  {
    label: 'In validaz. Contratto con SEPA',
    payload: null,
    id: 'In validaz. Contratto con SEPA',
  },
  {
    label: 'Contratto non attivato',
    payload: null,
    id: 'Contratto non attivato',
  },
  {
    label: 'In validaz. Contratto MAAF',
    payload: null,
    id: 'In validaz. Contratto MAAF',
  },
  {
    label: 'In validaz. da flusso SEDA',
    payload: null,
    id: 'In validaz. da flusso SEDA',
  },
  {
    label: 'In validaz. da flusso HR',
    payload: null,
    id: 'In validaz. da flusso HR',
  },
  {
    label: 'Non Attivabile - Diniego SEPA',
    payload: null,
    id: 'Non Attivabile - Diniego SEPA',
  },
  {
    label: 'In Validazione Contratto',
    payload: null,
    id: 'In Validazione Contratto',
  },
  {
    label: 'Non Attivabile',
    payload: null,
    id: 'Non Attivabile',
  },
  {
    label: 'In validaz. da flusso PT Inv.',
    payload: null,
    id: 'In validaz. da flusso PT Inv.',
  },
  {
    label: 'In validaz. da flusso REBA',
    payload: null,
    id: 'In validaz. da flusso REBA',
  },
  {
    label: 'In validaz. da flusso massivo',
    payload: null,
    id: 'In validaz. da flusso massivo',
  },
  {
    label: 'Reinoltrato SFA da BOI',
    payload: null,
    id: 'Reinoltrato SFA da BOI',
  },
  {
    label: 'In attesa integrazione Billing',
    payload: null,
    id: 'In attesa integrazione Billing',
  },
  { label: 'Concluso', payload: null, id: 'Concluso' },
  {
    label: 'In validaz. da flusso POSTEWEB',
    payload: null,
    id: 'In validaz. da flusso POSTEWEB',
  },
  {
    label: 'In validaz. Contratto CRONO',
    payload: null,
    id: 'In validaz. Contratto CRONO',
  },
  {
    label: 'In validazione da BOI',
    payload: null,
    id: 'In validazione da BOI',
  },
  { label: 'Contratto attivato', payload: null, id: 'Contratto attivato' },
  {
    label: 'Annullato',
    payload: null,
    id: 'Annullato',
  },
  {
    label: 'In validaz. da flusso Postel',
    payload: null,
    id: 'In validaz. da flusso Postel',
  },
  {
    label: 'Reinoltrato per verifiche SFA',
    payload: null,
    id: 'Reinoltrato per verifiche SFA',
  },
  {
    label: 'Contr. Attivato Parzialmente',
    payload: null,
    id: 'Contr. Attivato Parzialmente',
  },
  {
    label: 'In validaz. Contratto PW',
    payload: null,
    id: 'In validaz. Contratto PW',
  },
  { label: 'Sospeso', payload: null, id: 'Sospeso' },
  {
    label: 'Reinoltrato per verifiche B/O',
    payload: null,
    id: 'Reinoltrato per verifiche B/O',
  },
  {
    label: 'In validaz. da flusso SPID',
    payload: null,
    id: 'In validaz. da flusso SPID',
  },
  {
    label: 'In validazione da integr. SFA',
    payload: null,
    id: 'In validazione da integr. SFA',
  },
  {
    label: 'In attesa documentazione',
    payload: null,
    id: 'In attesa documentazione',
  },
  {
    label: 'In validaz. Contratto Premium',
    payload: null,
    id: 'In validaz. Contratto Premium',
  },
  {
    label: 'In Validazione Anagrafica',
    payload: null,
    id: 'In Validazione Anagrafica',
  },
  {
    label: 'In approvaz. Mandato SEPA BP',
    payload: null,
    id: 'In approvaz. Mandato SEPA BP',
  },
  {
    label: 'Restituito per diniego SEPA',
    payload: null,
    id: 'Restituito per diniego SEPA',
  },
  { label: 'Modificato', payload: null, id: 'Modificato' },
  {
    label: 'In validaz. da flusso migraz.',
    payload: null,
    id: 'In validaz. da flusso migraz.',
  },
  {
    label: 'In validaz. da flusso SDA',
    payload: null,
    id: 'In validaz. da flusso SDA',
  },
];
